function submissionErrorHandler(values, validator, props) {
    const invalidFields = validator(values, props);
    let errors = [];
    for (let field in invalidFields) {
        errors.push(field);
    }
    if (errors.length > 0) {
        return errors;
    } else {
        return [];
    }
}

export default submissionErrorHandler;
